export default __webpack_public_path__ + "static/body-v2-04-torso-be80cb3f950fffe34e5a8bf6fa542d0d.png";